export const toError = (error: unknown): Error => {
  if (error instanceof Error) return error;

  let message: string;

  if (typeof error === 'string') {
    message = error;
  } else {
    try {
      const serialized = JSON.stringify(error);
      message = serialized ?? `Non-Error thrown (type: ${typeof error})`;
    } catch {
      message = 'ErrorNormalizationFailed: Unable to serialize thrown value';
    }
  }

  const wrapper = new Error(message);
  wrapper.cause = error;
  return wrapper;
};
